module.exports = __webpack_public_path__ + "img/calendar.e76e7fb7.svg";